import { Link } from "@tanstack/react-router";
import { Hash } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@/components/confirm-dialog";
import { Button } from "@/components/ui/button";

/**
 * "Compute KOReader document ids": disabled until the status is loaded, while a backfill is
 * queued or running (with a link to that job) and while the request is in flight.
 */
export function BackfillAction({
  filesWithoutDigest,
  activeJobId,
  starting = false,
  onStart,
}: {
  /** `undefined` while the status is loading or failed. */
  filesWithoutDigest: number | undefined;
  activeJobId: string | null;
  starting?: boolean;
  onStart: () => void;
}) {
  const { t } = useTranslation("jobs");
  const loaded = filesWithoutDigest !== undefined;
  return (
    <div className="grid justify-items-end gap-1">
      <ConfirmDialog
        trigger={
          <Button variant="outline" disabled={!loaded || activeJobId !== null || starting}>
            <Hash aria-hidden />
            {t("backfill.action")}
          </Button>
        }
        title={t("backfill.confirmTitle")}
        description={t("backfill.confirmDescription", { count: filesWithoutDigest ?? 0 })}
        confirmLabel={t("backfill.confirm")}
        onConfirm={onStart}
      />
      {loaded ? (
        <span className="text-muted-foreground text-xs" data-testid="backfill-pending">
          {t("backfill.pending", { count: filesWithoutDigest })}
        </span>
      ) : null}
      {activeJobId ? (
        <Link
          to="/admin/jobs/$jobId"
          params={{ jobId: activeJobId }}
          className="text-sm underline-offset-4 hover:underline"
        >
          {t("backfill.viewRunning")}
        </Link>
      ) : null}
    </div>
  );
}
